// Copyright 2018 Sisense Inc. All rights reserved.

/**
 * @fileoverview Index file for Sisense Core UI Components.
 * @author artem.lit@sisense.com (Artem Lytvynov)
 * @copyright sisense@sisense.com (Sisense Ltd.)
 * @license Sisense License
 * @module @sbi/core.navigation
 */

/**
 * @type {Html5History}
 */
const Html5History = require('./html5history').Html5History;

/**
 * @type {HistoryChanged}
 */
const HistoryChanged = require('./historychanged').HistoryChanged;

exports.Html5History = Html5History;
exports.HistoryChanged = HistoryChanged;
